import React, { Component } from 'react'
import SettingCategoryTab from './DefaultSetting/SettingCategoryTab'
import TabController from './DefaultSetting/TabController'

class DefaultSetting extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentTabId: 'GetsugakuSetting'
    }
  }
  onTabClick (tabId) {
    this.setState({
      currentTabId: tabId
    })
  }
  onDashButtonClicked (name) {
    switch (name) {
      case 'companyList':
        this.props.history.push('/admin/company')
        break
      case 'informationList':
        this.props.history.push('/admin/information')
        break
      case 'sharedFileList':
        this.props.history.push('/admin/shared_files')
        break
      case 'defaultSetting':
        this.props.history.push('/admin/default_setting')
        break
      case 'adminUserList':
        this.props.history.push('/admin/admin_user')
        break
      case 'passwordChange':
        this.props.history.push('/admin/password_change')
        break
      case 'emaiChange':
        this.props.history.push('/admin/email_change')
        break
      default:
        break
    }
  }
  render () {
    return (
      <div>
        <section className='nav nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>初期値設定<br /><small>こちらで年度別の初期値を設定できます。</small>
                  </h3>
                </header>
              </div>
              <div className='page-nav-options'>
                <div className='span9' />
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <div className='container'>
            <SettingCategoryTab onClick={this.onTabClick.bind(this)} defaultTab={this.state.currentTabId} />
            {TabController.getTab(this.state.currentTabId)}
          </div>
        </section>
      </div>
    )
  }
}

export default DefaultSetting



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting.js